import styled from "styled-components";

const LayoutContentStyle = styled.div`
  width: 100%;
  padding: 35px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 10px 30px rgb(92 92 92 / 10%);
  border: 1px solid #efefef;
  margin-bottom: 20px;
`;

export default LayoutContentStyle;
